import React from "react";

import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import Switch from "@mui/material/Switch";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Stack from "@mui/material/Stack";

function Locations(props) {
  const truncateText = (text, maxLength) => {
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };
  return (
    <div className="col-md-9">
      <section className="container">
        <Paper
          component="form"
          sx={{ p: "4px 4px", display: "flex", alignItems: "center" }}
          fullWidth
          elevation={0}
        >
          <Box>
            <Typography gutterBottom>{props.resource.title}</Typography>
            {props.resource &&
              Object.keys(props.resource.fields).map((fieldKey) =>
                Object.keys(props.resource.fields[fieldKey].paragraphs).map(
                  (paragraphKey) => (
                    <Accordion
                      sx={{ backgroundColor: "#F3F3F3" }}
                      elevation={0}
                      key={paragraphKey}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                      >
                        <Typography variant="subtitle1" gutterBottom>
                          <span>
                            {" "}
                            p.{" "}
                            {
                              props.resource.fields[fieldKey].paragraphs[
                                paragraphKey
                              ].position.page_number
                            }{" "}
                          </span>
                          <span sx={{ marginLeft: "20px" }}>
                            {truncateText(
                              props.resource.fields[fieldKey].paragraphs[
                                paragraphKey
                              ].text,
                              50
                            )}
                          </span>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Stack>
                          {
                            props.resource.fields[fieldKey].paragraphs[
                              paragraphKey
                            ].text
                          }
                        </Stack>
                      </AccordionDetails>
                    </Accordion>
                  )
                )
              )}
          </Box>
        </Paper>
      </section>
    </div>
  );
}

export default Locations;
